import { TranslationService } from "@services/translation.service";
import * as angular from "angular";

export class Translate implements angular.IDirective {

    restrict = "A";

    link: (scope: angular.IScope, element: ng.IAugmentedJQuery, attrs: ng.IAttributes) => void;

    constructor(private readonly translationService: TranslationService) {

        Translate.prototype.link = ($scope: angular.IScope, $element: angular.IAugmentedJQuery, $attrs: ng.IAttributes) => {            
            let translatedPhrase = this.translatePhrase($attrs.translate, $attrs.translateParams);

            $element.empty().append(translatedPhrase);
        }
    }

    translatePhrase(phrase: string, params?: any) {
        return this.translationService.t(phrase, params);
    }

    static factory(): angular.IDirectiveFactory {
        const directive = (translationService: TranslationService) => new Translate(translationService);

        directive.$inject = ["translationService"];

        return directive;
    }
}
